import React from 'react';
import { chartVenueAxisConfig } from '../../util/constants';

const formatNumber = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0
}).format;

export default function ChartToolTipTemplate (pointInfo) {
  const isTotalSeries = pointInfo.seriesName && pointInfo.seriesName.toLowerCase() === 'total';
  const data = pointInfo.point.data;
  return (
    <div className='state-tooltip'>
      <h4>{pointInfo.argument}</h4>
      { isTotalSeries && <div>
        <div>
          <div>
            <b>Total: </b>
            {formatNumber(pointInfo.value)}
          </div>
          <div>
            { chartVenueAxisConfig.map(function (venue, venueIndex) {
              return <div key={venueIndex}><b>{venue.value}: </b>{formatNumber(data[venue.value])}</div>;
            })}
          </div>
        </div>
      </div> }

      { !isTotalSeries && <div>
        <div key={'venue'}><b>{pointInfo.seriesName}: </b>{formatNumber(pointInfo.value)}</div>
        <div key={'venuePer'}><b>{pointInfo.seriesName + '(%)'}: </b>{pointInfo.percentText}</div>
        <div key={'total'}><b>{'Total'}: </b>{formatNumber(pointInfo.total)}</div>
      </div>}
    </div>
  );
}
